module.exports = __webpack_public_path__ + "img/partner9.063390a3.png";